import {
  Box,
  Paper,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Tabs
} from "@mui/material";
import React, { useState } from "react";
import {Link} from "react-router-dom";
import {FaEye} from "react-icons/fa";
import {notFound} from "../../../../enums/mainEnums";
import ElementSidbarHr from "../../../Sidebar/ElementSidbarHr";

const EmailDetailsPage = ({ data }) => {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      {
        <div className={`flex flex-col items-start`}>
          <div className="flex gap-12">
            <div className="user-data">
              <div className="flex flex-col items-start">
                <div className="user-name font-bold">{data?.user?.name}</div>
                <div className="user-email font-bold mb-4">{data?.subject}</div>
                <div className="user-details flex gap-10">
                  <div className="user-created-at flex flex-col items-start">
                    <div>email</div>
                    <div className="font-bold">{data?.user?.email}</div>{" "}
                  </div>
                  <div className="user-created-at flex flex-col items-start">
                    <div>Sent At</div>
                    <div className="font-bold">{data?.sent_at}</div>
                  </div>
                  <div className="user-created-at flex flex-col items-start">
                    <div>Opened At</div>
                    <div className="font-bold">{data?.opened_at}</div>
                  </div>
                  <div className="user-created-at flex flex-col items-start">
                    <div>Clicked At</div>
                    <div className="font-bold">{data?.clicked_at}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="description">
            {data?.provider_response?.length > 0 ?
                <div>Providers Response</div> : ""
            }
            <ol>
              {
                data?.provider_response?.length > 0 ?
                    data?.provider_response?.map((item) => {
                      return <>
                        <ElementSidbarHr />
                        <li className="font-bold" style={{textAlign:'left'}}>{item}</li>

                      </>
                    }) : ""
              }
            </ol>


          </div>
        </div>

      }
    </>
  );
};

export default EmailDetailsPage;
